import React, { useState, useEffect } from 'react';
import clsx from 'clsx';

const buttonVariants = {
  base: 'w-full flex gap-4 items-center justify-center rounded-md font-semibold transition-colors',
  sizes: {
    sm: 'px-16 py-4 text-sm',
    md: 'px-16 py-6 text-2xl',
    lg: 'px-16 py-8 text-lg',
  },
  variants: {
    primary: 'bg-brand-500 text-white hover:bg-brand-600',
    secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-gray-400',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
    outline: 'border border-gray-300 text-gray-700 hover:bg-gray-100',
    ghost: 'bg-transparent hover:bg-gray-100 text-gray-700',
  },
  disabled: 'opacity-80 cursor-not-allowed',
  loading: 'cursor-wait',
};

const ButtonRoot = React.forwardRef(
  (
    {
      children,
      size = 'md',
      variant = 'primary',
      disabled = false,
      loading = false,
      className,
      scrollToTop = false,
      ...props
    },
    ref
  ) => {
    const [showScroll, setShowScroll] = useState(true);

    useEffect(() => {
      if (!scrollToTop) return;
      const handleScroll = () => {
        setShowScroll(window.scrollY > 100);
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, [scrollToTop]);

    const handleClick = (e) => {
      if (scrollToTop) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      props.onClick?.(e);
    };

    if (scrollToTop && !showScroll) return null;

    return (
      <button
        ref={ref}
        onClick={handleClick}
        disabled={disabled || loading}
        className={clsx(
         
          !scrollToTop && buttonVariants.base,
          buttonVariants.sizes[size],
          !scrollToTop && buttonVariants.variants[variant],
          (disabled || loading) && buttonVariants.disabled,
          loading && buttonVariants.loading,
          scrollToTop && 'flex justify-center items-center fixed bottom-8 right-8 h-16 w-16 px-2 py-2 bg-white text-9xl hover:bg-white text-brand-500 border border-[#336ef033] shadow-[0_10px_50px_rgba(0,0,0,0.1)] rounded-lg',
          className
        )}
        {...props}
      >
        {children}
      </button>
    );
  }
);

export default ButtonRoot;
